/* Progressive tabs only. All cart/quantity/save behavior stays in the existing theme. */
(function () {
  function init() {
    document.querySelectorAll('[data-merch-tabs]').forEach(function (list) {
      const section = list.closest('.mf-section');
      if (section.hasAttribute('data-tabs-ready')) return;
      const tabs = Array.from(list.querySelectorAll('button'));
      const panels = tabs.map(tab => document.getElementById(tab.getAttribute('aria-controls')));
      if (tabs.length !== 2 || panels.some(panel => !panel)) return;
      function select(index, focus) {
        tabs.forEach((tab, i) => {
          tab.setAttribute('aria-selected', String(i === index));
          tab.tabIndex = i === index ? 0 : -1;
          panels[i].hidden = i !== index;
        });
        if (focus) tabs[index].focus();
      }
      list.setAttribute('role', 'tablist');
      list.setAttribute('aria-labelledby', section.querySelector('h2').id = 'mf-tabs-heading');
      tabs.forEach((tab, i) => {
        tab.setAttribute('role', 'tab');
        panels[i].setAttribute('role', 'tabpanel');
        panels[i].setAttribute('aria-labelledby', tab.id);
        tab.addEventListener('click', () => select(i, false));
        tab.addEventListener('keydown', event => {
          const next = {ArrowRight:(i + 1) % tabs.length, ArrowLeft:(i + tabs.length - 1) % tabs.length, Home:0, End:tabs.length - 1}[event.key];
          if (next === undefined) return;
          event.preventDefault(); select(next, true);
        });
      });
      select(0, false); list.hidden = false; section.setAttribute('data-tabs-ready', '');
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
}());
